import type { ProcessCatalogItem } from "common";

/**
 * Case insensitive substring match over the visible text of a catalog row:
 * name, summary, owner, menu group and every tag name. A blank query matches
 * everything.
 */
export const matchesProcessSearch = (
  item: ProcessCatalogItem,
  query: string
): boolean => {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  const haystack = [
    item.name,
    item.summary,
    item.ownerName,
    item.ownerUsername,
    item.menuGroupName,
    ...item.tags.map(tag => tag.name),
  ];
  return haystack.some(text => (text ?? "").toLowerCase().includes(needle));
};
